import { OrganizationException } from '@/domain/organization/exception/OrganizationException'

export class UnauthorizedException extends OrganizationException {
}
